module.exports = __webpack_public_path__ + "img/ic_jp.edaf8cbb.svg";